import PropTypes from "prop-types";
import { useRequest } from "src/hooks/use-request";
import { useAuth } from "src/hooks/use-auth";
import ErrorPage from "src/pages/dashboard/errors/500";

/**
 * Axios 오류, 인터셉터가 반환한 API 오류 본문, 일반 Error에서 관리자용 상세 메시지를 찾는다.
 */
const getErrorMessage = (error) => {
  const responseData = error?.response?.data;
  if (typeof responseData?.message === "string" && responseData.message) {
    return responseData.message;
  }
  if (typeof error?.message === "string" && error.message) {
    return error.message;
  }
  if (typeof responseData === "string" && responseData) {
    return responseData;
  }
  return undefined;
};

export const ErrorGuard = (props) => {
  const { children } = props;
  const { error } = useRequest();
  const { user } = useAuth();

  if (error) {
    // apt newwindow처럼 인터셉터를 거친 오류도 관리자는 실제 서버 메시지를 확인해야 한다.
    const responseMessage = getErrorMessage(error);
    const message = user?.isAdmin && responseMessage
      ? responseMessage
      : "서버 에러가 발생했습니다.";
    return <ErrorPage message={message} />;
  }

  return <>{children}</>;
};

ErrorGuard.propTypes = {
  children: PropTypes.node,
};
